import {Injectable} from '@angular/core';
import {CylinderConstraint, OrbitControlConstraint} from '../classes/orbitControlConstraint';
import {SceneryService} from './scenery.service';

@Injectable()
export class CameraConstraintService {

  private constraints: OrbitControlConstraint[] = [];

  constructor(
    envSrvc: SceneryService
  ) {
    envSrvc.onChange.subscribe(env => {
      const back = env.getObjectByName('back');
      if (back) {
        this.addConstraintIfNotExist(CylinderConstraint, () => new CylinderConstraint(back));
      }
    });
  }

  validate(camera, newPosition): boolean {
    return this.constraints.every(c => c.check(camera, newPosition));
  }

  addConstraint(constraint: OrbitControlConstraint) {
    this.constraints.push(constraint);
  }

  addConstraintIfNotExist(constraintType: new (...args) => OrbitControlConstraint, constraintCreator: () => OrbitControlConstraint) {
    const constraints = this.constraints;
    const exist = constraints.find(c => c instanceof constraintType);
    if (!exist) {
      constraints.push(constraintCreator());
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/camera-constraint.service.ts